import type { Form } from '../../../../common/types/form';
import type { Client } from '../../../../common/types/client';
import formatter from '../../../../common/helpers/formatter';

const moveOutForm: Form<Client> = {
  key: 'moveOut',
  title: 'Auszug aus Frauenhaus',
  fields: [
    {
      key: 'moveOutDate',
      label: 'Datum',
      fieldTypes: 'date',
      helpText: (client) => {
        const days = formatter.getDaysBetweenTwoDates(client.moveInDate, client.moveOutDate);
        return `${days} Tage`;
      },
    },
  ],
};

export default moveOutForm;
